import { isEqual } from "lodash";
import { useState } from "react";

import { PositionDateQuickFilter } from "./interfaces";

export const usePositionDateQuickFilter = (position?: boolean) => {
  const [quickFilter, setQuickFilter] = useState<PositionDateQuickFilter>({
    positionDate: {
      fromMonthsAgo: position ? null : 3,
    },
  });

  const handleChangeQuickFilter = (
    filter: keyof PositionDateQuickFilter,
    value: PositionDateQuickFilter["positionDate"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    positionDateQuickFilter: quickFilter,
    setPositionDateQuickFilter: handleChangeQuickFilter,
  };
};
